import styled from "styled-components";
import useChart from "../hooks/useChart";
import { useDispatch } from "react-redux";
import { Carousel } from "../components/Carousel";
import { toggleProduct } from "../store/chart";

export function ProductCarousel() {
  const dispatch = useDispatch();
  const {
    data: { showPrice, styling, desktop },
  } = useChart();

  function handleProductToggle(filterId: string) {
    dispatch(toggleProduct({ productId: filterId, isMobile: false }));
  }

  return (
    <StyledCarousel
      filteredProducts={desktop.filteredProducts}
      selectedProducts={desktop.selectedProducts}
      showPrice={showPrice}
      styling={styling}
      onProductToggle={handleProductToggle}
    />
  );
}

const StyledCarousel = styled(Carousel)`
  margin-top: ${({ theme }) => theme.getValue(46)}px;
`;
